
import { FC } from 'react';
import { Alert, AlertProps, AlertTitle, Box, Card, styled, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { CustomError } from '@/context/ErrorContext';


interface IErrorPageProps {
    error: CustomError;
}

const Center = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px'
}));

const StyledAlert = styled(Alert, { shouldForwardProp: (props) => props !== "styleSeverity" })<AlertProps & { styleSeverity?: "warning" | "info" | "success" | "error" }>(({ styleSeverity, theme }) => ({
    borderRadius: '10px',
    border: `1px solid ${theme.palette[styleSeverity ?? "info"].dark}55`,
    width: '100%',
    minWidth: '400px'
}));

const StyledCloseIcon = styled(CloseIcon)(({ }) => ({
    fontSize: '2.4rem'
}));

const ErrorPage: FC<IErrorPageProps> = ({
    error
}) => {

    return (
        <Center 
            width="100%"
            height='100%' 
            padding="200px"
        >
            <StyledAlert
                icon={<StyledCloseIcon />}
                severity={'error'}
                styleSeverity={'error'}
                sx={{mt: 2}}
            >
                <Typography fontWeight='500' variant='h2' gutterBottom>Error</Typography>
                <Typography fontWeight='400' variant='h3'>{error.message}</Typography>
            </StyledAlert>
        </Center>
    )
}

export default ErrorPage;